import { RecommendationCard } from '~src/app/spaces/CardView/RecommendationCard';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const RecommendedViewDefinition: ExplorableItemDefinition = {
  itemType: 'recommendedView',
  pluralName: Messages.recommendations,
  singularName: Messages.recommendation,
  emptyStateMessage: Messages.recommendationsEmptyMessage,
  contentFilterKeys: null,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: RecommendationCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => null,
  getContentInfo: () => {
  },
  supportedDisplayModes: ['thumbnail'],
};
